import { Payment } from '@melio/platform-api';

export const extractAccountNameFromPayment = (payment: Payment) =>
  `${payment.createdBy?.firstName || ''} ${payment.createdBy?.lastName || ''}`;
